export const isStageEnvironment = (): boolean => {
	const apiUrl = import.meta.env.VITE_API_URL || '';
	return apiUrl.includes('stage');
};

export const shouldShowTemplateIds = (): boolean => {
	return isStageEnvironment();
};
